import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import ListGroup from "react-bootstrap/ListGroup";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Container from "react-bootstrap/Container";
import { Spinner, Stack } from "react-bootstrap";
import PendingProvidersDetails from "../details/PendingProvidersDetails";
import Prompt from "../../ui/prompts/Prompt";
import {
  Title,
  SpinnerContainer,
  ViewsContainer,
  ContentHeader,
  ViewsTitleContainer,
} from "../../ui/BaseComponents";

const ApprovalStatusCard = ({ status }) => {
  const statusTextMap = {
    PENDING_ADMIN_INPUT: "Admin Needs to send background check",
    PENDING_PROVIDER_INPUT:
      "The Provider needs to complete their background check",
    IN_REVIEW: "The background check is in review",
    REJECTED: "Background Check Rejected",
    APPROVED: "Background Check Approved",
  };

  const statusBgColorMap = {
    PENDING_ADMIN_INPUT: "#FF7F7F",
    PENDING_PROVIDER_INPUT: "orange",
    IN_REVIEW: "#57B9FF",
    REJECTED: "red",
    APPROVED: "green",
  };

  return (
    <div
      style={{
        padding: 10,
        backgroundColor: statusBgColorMap[status],
        color: "white",
        borderRadius: 9,
        fontSize: 13,
      }}
    >
      <span>{statusTextMap[status]}</span>
    </div>
  );
};

export default function ViewProvidersByStatus({ data, isLoading }) {
  const [savedId, setSavedId] = useState<any>();
  const [pendingProviders, setPendingProviders] = useState<any[]>(
    data.filter((provider) => !provider.approved)
  );

  const updateData = (updatedData) => {
    let newPendingProviders = pendingProviders.reduce(
      (newPendingProviders: any[], pendingProvider: any) => {
        if (pendingProvider.id === updatedData.id) {
          pendingProvider = updatedData;
        }
        newPendingProviders.push(pendingProvider);
        return newPendingProviders;
      },
      []
    );
    newPendingProviders = newPendingProviders.filter(
      (provider) => !provider.approved
    );
    setPendingProviders(newPendingProviders);
  };

  useEffect(() => {
    setPendingProviders(data);
  }, [data]);

  return (
    <Container fluid>
      <Title>{"Provider Details"}</Title>
      {isLoading ? (
        <SpinnerContainer>
          <Spinner animation='grow' variant='danger' />
          <Spinner animation='grow' variant='danger' />
          <Spinner animation='grow' variant='danger' />
        </SpinnerContainer>
      ) : (
        <Stack>
          <ContentHeader>
            {"Service Providers that are pending approval"}
          </ContentHeader>
          <Row className='justify-content-md-center'>
            <Tab.Container
              id='list-group-tabs-example'
              defaultActiveKey={savedId}
            >
              <Col xs lg='5'>
                <ViewsContainer style={{ marginLeft: "5%" }}>
                  <ViewsTitleContainer>
                    {"Pending Providers"}
                  </ViewsTitleContainer>
                  <ListGroup>
                    {pendingProviders.map((item: any, i) => (
                      <ListGroup.Item
                        style={
                          i % 2 === 0
                            ? {
                                height: "4em",
                                color: "#292929",
                                backgroundColor: "#D8ECFD",
                                borderStyle: i === savedId ? "solid" : "none",
                                borderColor: "orange",
                                borderWidth: 2,
                              }
                            : {
                                height: "4em",
                                color: "#292929",
                                backgroundColor: "#ECF3FE",
                                borderStyle: i === savedId ? "solid" : "none",
                                borderColor: "orange",
                                borderWidth: 2,
                              }
                        }
                        key={i}
                        action
                        variant='dark'
                        eventKey={i}
                        onClick={() => setSavedId(i)}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <span>
                            {item.first_name} {item.last_name}
                          </span>
                          <span style={{ marginLeft: "auto" }}>
                            <ApprovalStatusCard
                              status={item.background_check_status}
                            />
                          </span>
                        </div>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </ViewsContainer>
              </Col>

              <Col xs lg='7'>
                <ViewsContainer style={{ marginRight: "5%" }}>
                  <ViewsTitleContainer>{"Details"}</ViewsTitleContainer>
                  <Tab.Content style={{ padding: ".4em" }}>
                    {savedId === undefined ? (
                      <Prompt message='Select a pending provider to view details.' />
                    ) : (
                      <Tab.Pane eventKey={savedId}>
                        {typeof savedId === "number" ? (
                          <PendingProvidersDetails
                            data={pendingProviders[savedId]}
                            id={pendingProviders[savedId].provider_id}
                            updateListData={updateData}
                          />
                        ) : null}
                      </Tab.Pane>
                    )}
                  </Tab.Content>
                </ViewsContainer>
              </Col>
            </Tab.Container>
          </Row>
        </Stack>
      )}
    </Container>
  );
}
